import * as React from "react";
import type { SVGProps } from "react";
const SvgMastercardAndVisaOnCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#mastercard-and-visa-on-card_svg__a)">
      <path
        fill="#0e4595"
        d="M5 13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z"
      />
      <path
        fill="#fff"
        d="m11.239 17.794.607-3.561h.97l-.607 3.561zm4.477-3.484a2.5 2.5 0 0 0-.87-.15c-.959 0-1.635.483-1.64 1.175-.006.512.482.797.85.968.378.174.505.286.503.442-.002.238-.301.347-.58.347-.389 0-.595-.053-.914-.186l-.125-.057-.137.797c.227.1.646.186 1.082.19 1.02 0 1.683-.477 1.69-1.217.004-.405-.255-.713-.815-.967-.34-.165-.547-.275-.545-.442 0-.148.176-.306.556-.306a1.8 1.8 0 0 1 .727.136l.087.042zm2.498-.077h-.75c-.232 0-.406.063-.508.295l-1.442 3.264h1.02s.166-.439.204-.535l1.243.001c.03.125.118.534.118.534H19zm-1.19 2.3.387-.996c-.006.01.08-.206.129-.34l.065.307.225 1.028zm-6.61-2.3-.95 2.428-.1-.493c-.178-.569-.73-1.185-1.345-1.494l.869 3.114h1.027l1.528-3.555z"
      />
      <path
        fill="#f2ae14"
        d="M8.578 14.233H7.012L7 14.307c1.218.294 2.024 1.007 2.358 1.863l-.34-1.637c-.059-.225-.23-.293-.44-.3"
      />
    </g>
    <g clipPath="url(#mastercard-and-visa-on-card_svg__b)">
      <path
        fill="#fff"
        d="M3 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
      />
      <path
        fill="#c9c9c9"
        fillRule="evenodd"
        d="M17 3.5H5A1.5 1.5 0 0 0 3.5 5v6A1.5 1.5 0 0 0 5 12.5h12a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 17 3.5M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z"
        clipRule="evenodd"
      />
      <path fill="#ff5f00" d="M9.56 5.641h2.887v4.717H9.56z" />
      <path
        fill="#eb001b"
        d="M9.857 8a3 3 0 0 1 1.146-2.357 3 3 0 1 0 0 4.716A3 3 0 0 1 9.857 8"
      />
      <path
        fill="#f79e1b"
        d="M15.856 8a3 3 0 0 1-4.853 2.358 3 3 0 0 0 0-4.717A2.999 2.999 0 0 1 15.856 8"
      />
    </g>
    <defs>
      <clipPath id="mastercard-and-visa-on-card_svg__a">
        <path fill="#fff" d="M5 11h16v10H5z" />
      </clipPath>
      <clipPath id="mastercard-and-visa-on-card_svg__b">
        <path fill="#fff" d="M3 3h16v10H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMastercardAndVisaOnCard;
